import { type ComponentStyleConfig } from '@chakra-ui/react'

import { pxToEm } from '../../utils/pxToEm'
import { pxToRem } from '../../utils/pxToRem'

export const Heading: ComponentStyleConfig = {
  baseStyle: {
    wordBreak: 'break-word',
  },
  variants: {
    H1B: {
      fontSize: [pxToRem(32), null, null, pxToRem(50)],
      fontWeight: '300',
      lineHeight: [pxToRem(46), null, null, pxToRem(60)],
    },
    H1: {
      fontSize: [pxToEm(32), pxToEm(36), null, pxToEm(50)],
      fontWeight: '300',
      lineHeight: '116%',
    },
    H2: {
      fontSize: [pxToRem(30), null, null, pxToRem(48)],
      fontWeight: '300',
      lineHeight: '125%',
    },
    H3B: {
      fontSize: pxToRem(32),
      fontWeight: '300',
      lineHeight: '125%',
    },
    H3: {
      fontSize: pxToRem(32),
      fontWeight: '300',
      lineHeight: '125%',
    },
    H4: {
      fontSize: pxToRem(24),
      fontWeight: '300',
      lineHeight: '125%',
    },
    subheading: {
      color: 'primary.grey.90',
      fontFeatureSettings: "'clig' off, 'liga' off",
      fontFamily: 'Gotham Rounded',
      fontSize: [pxToRem(14), null, null, pxToRem(18)],
      fontStyle: 'normal',
      fontWeight: 300,
      lineHeight: 'normal',
      textTransform: 'uppercase',
    },

    wysiwyg_h1: {
      fontSize: [pxToEm(30), pxToEm(36), null, pxToEm(50)],
      fontWeight: '300',
      lineHeight: '125%',
      mb: pxToRem(42),
    },
    wysiwyg_h2: {
      fontSize: pxToEm(32),
      fontWeight: '300',
      lineHeight: '125%',
      mb: pxToRem(26),
    },
    wysiwyg_h3: {
      fontSize: pxToEm(24),
      fontWeight: '300',
      lineHeight: '125%',
      mb: pxToRem(26),
    },
    wysiwyg_h4: {
      fontSize: pxToEm(22),
      fontWeight: '300',
      lineHeight: '125%',
      mb: pxToRem(26),
    },
    wysiwyg_h5: {
      fontSize: pxToEm(20),
      fontWeight: '300',
      lineHeight: '125%',
      mb: pxToRem(26),
    },
    wysiwyg_h6: {
      fontSize: pxToEm(20),
      fontWeight: '300',
      lineHeight: '125%',
      mb: pxToRem(26),
    },
  },
}
